import { Functions, httpsCallable } from 'firebase/functions';

export async function logAppError(
  functions: Functions,
  errorData: { message: string; stack: string | null },
  path: string
): Promise<{ shouldDisplayTechnicalData: boolean }> {
  const logAppErrorFn = httpsCallable<{
    error: { message: string; stack: string | null };
    path: string;
  }, { shouldDisplayTechnicalData: boolean }>(functions, 'logAppError');
  const result = await logAppErrorFn({
    error: errorData,
    path,
  });
  return result.data;
}
